import React from 'react';
import { Grid, /* Header, */ Segment, Progress, Icon, Modal } from 'semantic-ui-react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import ReactGA from 'react-ga';

import PJModal from './componentsHelpers/Modal';
import WorkFormA from './components/WorkFormA';
import WorkFormB from './components/WorkFormB';
import AddressForm from './components/AddressForm';
import PersonalDetailsForm from './components/PersonalDetailsForm';
import ConsentForm from './components/ConsentForm';
import InformationSheetForm from './components/InformationSheetForm';
import DBAFormTwo from './components/DBAFormTwo';
import OnfidoInitialCheck from './components/OnfidoInitialCheck';
import OnfidoDocumentUpload from './components/OnfidoDocumentUpload';
import AQSelector from './components/AQSelector';
import AQPayslip from './components/AQPayslip';
import AQQuestionnaire from './components/AQQuestionnaire';
import AQPreviousJobs from './components/AQPreviousJobs';
import EmailForm from './components/EmailForm';

import { postLead, putLead, getLead, postPayslipUpload } from './api/request';
import adapter from './utilities/adapter';
import { queryString } from './utilities/queryString';
import setInjectionStep from './utilities/setInjectionStep';
import regexs from './utilities/regexs';
import messages from './utilities/validationMessages';

// import DisplayFormikState from './componentsFormik/DisplayFormikState';
//import { testData } from './utilities/testData';

import './App.css';

class App extends React.Component<any, any> {
  state: any = {
    step: 1,
    backStep: null,
    percent: 16.67,
    motivation: 0,
    leadId: '',
    modalOpen: false,
    modalSize: 'mini',
    modalContent: null,
    uploadedDocs: false,
    sessionMarketingDataSent: false,
    revisitingLead: false,
    formData: {
      //...testData,
      stp1_worked: '',

      stp2_startDate: '',
      stp2_endDate: '',
      stp2_stillWorkThere: '',

      stp3_postCode: '',
      stp3_houseNumName: '',
      stp3_streetRoad: '',
      stp3_town: '',
      stp3_country: '',

      stp4_firstName: '',
      stp4_title: '',
      stp4_lastName: '',
      stp4_emailAddress: '',
      stp4_telephone: '',
      stp4_dob: '',
      stp4_gender: '',
      stp4_nationalInsurance: '',

      stp5_consentPermission: false,
      stp5_consentPrivacy: false,
      stp5_consentIdentity: false,

      stp6_infoSheetRead: false,
      stp6_infoSheetReadTS: '',

      stp7_dbaAgreed: false,
      stp7_dbaAgreedTS: '',
      stp7_dbaAgreedSignature: '',

      stpDocUpload_type: '',
      stpDocUpload_file: '',

      aq_type: '',
      aq_payslip_link: '',

      aq_employeeNum: '',
      aq_filePayslip: '',

      aq_maidenName: '',
      aq_jobTitle: '',
      aq_nationalInsurance: '',
      aq_dateStarted: '',
      aq_dateEnded: '',

      aq_jobCode: '',
      aq_branchName: '',
      aq_branchNumber: '',
      aq_branchAddress: '',
      aq_hourlyPay: '',
      aq_hoursPerWeek: '',

      aq_jobChangedLastSixYears: '',

      aq_prevJobTitle: '',
      aq_prevDateStarted: '',
      aq_prevDateEnded: '',
      aq_prevJobCode: '',
      aq_prevBranchName: '',
      aq_prevBranchNumber: '',
      aq_prevBranchAddress: '',
      aq_prevHourlyPay: '',
      aq_prevHoursPerWeek: '',

      aq_additionalInfo: '',

      email_input: ''
    }
  };

  componentDidMount() {
    this.initializeReactGA();

    const queryString: boolean = regexs.leadUUid.test(window.location.href) || window.location.href.includes('retargeted');

    if (queryString) {
      //open modal wile lead is routed
      this.setState({
        modalOpen: true,
        modalContent: this.modalContent('Please wait, this won\'t take long', 'We are redirecting you...', true)
      });
      this.handleRevisitingLead();
    };

    Object.assign(window, { PJ_Email_Form: () => this.manualStep('EMAIL_FORM') });
  };

  initializeReactGA() {
    ReactGA.initialize('UA-35903174-15', { testMode: true });
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  gaEvent = (
    hitType: string,
    eventCategory: string,
    eventAction: string,
    eventLabel: string,
    isValid: boolean
  ): void => {
    if (isValid) {
      console.log(`GA event: hitType - ${hitType}, eventCategory - ${eventCategory}, eventAction - ${eventAction}, eventLabel - ${eventLabel}`);
      ReactGA.ga('send', {
        hitType,
        eventCategory,
        eventAction,
        eventLabel
      });
    }
  }

  handleRevisitingLead = () => {
    if (regexs.leadUUid.test(window.location.href)) {
      // if lead has a lead_id query string in the URL
      const uuid: string | null = queryString('lead_id')
      this.routeRevisitingLead(uuid)
    }
    // if a lead has 'retagrgeted' query string in the url
    else if (window.location.href.includes('retargeted')) {
      this.setState({
        modalOpen: false
      })
      this.manualStep('EMAIL_FORM');
    }
  };

  routeRevisitingLead = (uuid: string | null) => {
    getLead(uuid)()
      .then(response => {
        const { data } = response;
        let { step } = setInjectionStep(data);

        this.setState({
          revisitingLead: true,
          leadId: uuid,
          modalOpen: false,
          step
        });
      })
      .catch(error => {
        this.manualStep(0);
        console.log(error);
      });
  };

  prevStep = () => {
    const { step, percent, motivation } = this.state;
    this.setState({
      step: step - 1,
      percent: percent * ((step - 1) / step),
      motivation: motivation - 1
    });
  };

  nextStep = (props: any) => {
    props.submitForm().then(() => {
      if (props.isValid) {
        this.pushToCMS(props.values);

        const { step, percent, motivation } = this.state;
        this.setState({
          step: step + 1,
          percent: (percent / step) * (step + 1),
          motivation: motivation + 1
        });

        props.validateForm();
        props.setTouched({});
      }
    });
  };

  manualStep = (
    step: number | string,
    backStep: (null | number | string) = null,
    percent: (null | number) = null,
    motivation: (null | string) = null,
    props?: any,
    validate?: boolean,
    uploadedDocs: (boolean) = false
  ) => {
    if (validate || props) {
      props.submitForm().then(() => {
        if (props.isValid) {
          this.pushToCMS(props.values);

          this.setState({
            step: step,
            backStep: backStep,
            percent: percent,
            motivation: motivation,
            uploadedDocs: uploadedDocs,

            modalOpen: step === 'FINALLY' ? true : false,
            modalContent: step === 'FINALLY' ? this.modalContent('Thank you, we will be intouch soon...', '', true) : null
          });

          props.validateForm();
          props.setTouched({});
        }
      });
    } else {
      this.setState({
        step: step,
        backStep: backStep,
        percent: percent,
        motivation: motivation
      });
    }
  };

  modalContent = (title: string, msg?: string, spinner?: boolean) => {
    return (
      <React.Fragment>
        <Modal.Header style={{ textAlign: 'center' }}>{title}</Modal.Header>
        <Modal.Content style={{ textAlign: 'center' }}>
          {spinner ? <Icon loading name='spinner' size='massive' /> : null}
          <br />
          {msg ? <p>{msg}</p> : null}
        </Modal.Content>
      </React.Fragment>
    );
  };

  getValidationSchema = () => {
    if (this.state.step === 9) {
      return this.DocumentUploadSchema
    } else if (this.state.step === 'PAYSLIP') {
      return this.PayslipSchema
    } else if (this.state.step === 'QUESTIONNAIRE') {
      return this.QuestionnaireSchema
    } else if (this.state.step === 'EMAIL_FORM') {
      return this.EmailFormSchema
    } else {
      return this.schemaArray[this.state.step - 1]
    }
  }

  checkMarketingStr = (param: string): string | void => {
    const val = queryString(param);

    if (val) {
      return val + ': ' + moment().format('DD/MM/YYYY');
    }
  };

  // function will create object of K:V pairs of marketing info
  getMarketingData = () => {
    const queries = [
      'utm_term',
      'utm_source',
      'utm_medium',
      'utm_content',
      'utm_campaign'
    ];

    let marketingData = queries.reduce((queryObj: any, qString) => {
      let data = this.checkMarketingStr(qString);
      if (data) queryObj[qString.slice(4)] = data;
      return queryObj
    }, {});

    return marketingData;
  };

  pushToCMS = (formValues: any) => {
    const { sessionMarketingDataSent, step, leadId, revisitingLead } = this.state;
    //check if marketing data has already been sent this session, if not, get it
    let marketingData = sessionMarketingDataSent ? null : this.getMarketingData();

    switch (step) {
      case 5:
        this.setState({
          modalOpen: true,
          modalContent: this.modalContent('Please wait, this won\'t take long', 'Working...', true)
        });
        /* Completed Initial Registration */
        postLead(adapter(formValues, step, marketingData))()
          .then(response => {
            this.setState({
              leadId: response.data.id,
              sessionMarketingDataSent: true
            });
          })
          .catch(error => {
            this.manualStep(0);
            console.log(error);
          })
          .finally(() => {
            this.setState({
              modalOpen: false
            });
          });
        break;
      case 6:
        /* Accepted Info Sheet */
        putLead(leadId, adapter(formValues, step, marketingData))()
          .then(response => {
            //console.log(response);
            this.setState({
              sessionMarketingDataSent: true
            });
          })
          .catch(error => {
            this.manualStep(0);
            console.log(error);
          });
        break;
      case 7:
        /* Accepted DBA */
        putLead(leadId, adapter(formValues, step, marketingData, revisitingLead))()
          .then(response => {
            //console.log(response);
            this.setState({
              sessionMarketingDataSent: true
            });
          })
          .catch(error => {
            this.manualStep(0);
            console.log(error);
          });
        break;
      case 9:
        /* ID Docs Uploaded */
        putLead(leadId, adapter(formValues, step, marketingData))()
          .then(response => {
            //console.log(response);
            this.setState({
              sessionMarketingDataSent: true
            });
          })
          .catch(error => {
            this.manualStep(0);
            console.log(error);
          });
        break;
      case 'PAYSLIP':
        /* Fully Onboarded Claimant */
        if (formValues.aq_jobChangedLastSixYears === "No") {
          //upload payslip if there is one
          if (formValues.aq_filePayslip) {
            let document = formValues.aq_filePayslip;
            document.new_file_name = `${formValues.stp4_firstName}_${formValues.stp4_lastName}_(boots)`;
            this.paySlipUpload(document, formValues).then(() => {
              return putLead(leadId, adapter(formValues, step, marketingData))();
            }).then(response => {
              //console.log(response);
              this.setState({
                sessionMarketingDataSent: true
              });
            })
              .catch(error => {
                this.manualStep(0);
                console.log(error);
              });

          } else {

            putLead(leadId, adapter(formValues, step, marketingData))()
              .then(response => {
                //console.log(response);
                this.setState({
                  sessionMarketingDataSent: true
                });
              })
              .catch(error => {
                this.manualStep(0);
                console.log(error);
              });
          }

        }
        break;
      case 'QUESTIONNAIRE':
        /* Fully Onboarded Claimant */
        if (formValues.aq_jobChangedLastSixYears === "No") {
          putLead(leadId, adapter(formValues, step, marketingData))()
            .then(response => {
              //console.log(response);
              this.setState({
                sessionMarketingDataSent: true
              });
            })
            .catch(error => {
              this.manualStep(0);
              console.log(error);
            });
        }
        break;
      case 'PREVIOUS_JOBS':
        /* Fully Onboarded Claimant */
        if (formValues.aq_jobChangedLastSixYears === "Yes") {
          //upload payslip if there is one
          if (formValues.aq_filePayslip) {
            let document = formValues.aq_filePayslip;
            document.new_file_name = `${formValues.stp4_firstName}_${formValues.stp4_lastName}_(boots)`;
            this.paySlipUpload(document, formValues).then(() => {
              return putLead(leadId, adapter(formValues, step, marketingData))();
            }).then(response => {
              //console.log(response);
              this.setState({
                sessionMarketingDataSent: true
              });
            })
              .catch(error => {
                this.manualStep(0);
                console.log(error);
              });

          } else {

            putLead(leadId, adapter(formValues, step, marketingData))()
              .then(response => {
                //console.log(response);
                this.setState({
                  sessionMarketingDataSent: true
                });
              })
              .catch(error => {
                this.manualStep(0);
                console.log(error);
              });
          }
        }
        break;
      default:
        //TODO: DO SOMETHING
        break;
    }
  };

  paySlipUpload = (aq_filePayslip: {}, formValues: any) => {
    return new Promise((resolve, reject) => {

      postPayslipUpload(aq_filePayslip)().then((response) => {
        if (response) {
          const awsLink = response.data.replace('https://onlob-payslips.s3.eu-west-2.amazonaws.com', 'https://d1yk6jlc5m04mm.cloudfront.net');
          formValues.aq_payslip_link = awsLink;
          resolve(awsLink);
        }
      }).catch(error => {
        if (error) {
          //just resolve for now - don't block form submission
          formValues.aq_payslip_link = 'Issue uploading - contact lead.';
          resolve(error);
        }
      });
    });
  };

  Step1Schema = Yup.object().shape({
    stp1_worked: Yup.string().test(
      `step one - must have worked at Boots`,
      messages.stp1.mustHaveWorked,
      function(val) {
        return val === 'yes';
      }
    )
  });

  Step2Schema = Yup.object().shape({
    stp2_startDate: Yup.string()
      .required(messages.stp2.startDate)
      .test('step two - missing start date', messages.stp2.startDate, function(
        val
      ) {
        return moment(val, 'DD/MM/YYYY', true).isValid();
      })
      .test(
        'step two - start date cannot be in the future',
        messages.stp2.startDateFuture,
        function(val) {
          let endDate = moment(val, 'DD/MM/YYYY');
          let today = moment();
          return endDate.isBefore(today, 'day');
        }
      ),
    // .test(
    //   'step two - start date less than 2 months',
    //   messages.stp2.lessThan,
    //   function (val) {
    //     let startDate = moment(val, 'DD/MM/YYYY');
    //     let twoMonths = moment().subtract(2, 'months');
    //     return startDate.isBefore(twoMonths, 'day');
    //   }
    // ),
    stp2_stillWorkThere: Yup.mixed().required(messages.stp2.currentlyWorking),
    stp2_endDate: Yup.string().when('stp2_stillWorkThere', {
      is: val => val === 'no',
      then: Yup.string()
        .required(messages.stp2.endDate)
        .test('step two - missing end date', messages.stp2.endDate, function(
          val
        ) {
          return moment(val, 'DD/MM/YYYY', true).isValid();
        })
        .test(
          'step two - end date cannot be in the future',
          messages.stp2.endDateFuture,
          function(val) {
            let endDate = moment(val, 'DD/MM/YYYY');
            let today = moment();
            return endDate.isBefore(today, 'day');
          }
        )
        .test(
          'step two - end date cannot be before start date',
          messages.stp2.endBeforeStart,
          function(val) {
            let startDate = moment(
              this.resolve(Yup.ref('stp2_startDate')),
              'DD/MM/YYYY'
            );
            let endDate = moment(val, 'DD/MM/YYYY');
            return endDate.isAfter(startDate, 'day');
          }
        )
        .test(
          'step two - end date cannot be over 6 years',
          messages.stp2.moreThanSixYears,
          function(val) {
            let endDate = moment(val, 'DD/MM/YYYY');
            let sixYrs = moment().subtract(6, 'years');
            return endDate.isAfter(sixYrs, 'day');
          }
        )
    })
  });

  Step3Schema = Yup.object().shape({
    stp3_postCode: Yup.string()
      .required(messages.stp3.postcode)
      .test('step three - valid postcode', messages.stp3.postcodeValid, function(
        postCode
      ) {
        return regexs.postCodeValid.test(postCode);
      }),
    stp3_houseNumName: Yup.string()
      .required(messages.stp3.houseNumName)
      .min(1, messages.stp3.houseNumName)
      .max(50, messages.stp3.houseNumName),
    stp3_streetRoad: Yup.string()
      .required(messages.stp3.streetRoad)
      .min(5, messages.stp3.streetRoad)
      .max(50, messages.stp3.streetRoad),
    stp3_town: Yup.string()
      .required(messages.stp3.townCity)
      .min(3, messages.stp3.townCity)
      .max(50, messages.stp3.townCity),
    stp3_country: Yup.string()
      .required(messages.stp3.country)
      .test('step three - valid country', messages.stp3.countryValid, function(
        country
      ) {
        return country === "England" || country === "Scotland" || country === "Wales" ? true : false;
      })
  });

  Step4Schema = Yup.object().shape({
    stp4_title: Yup.string().required(messages.stp4.title),
    stp4_firstName: Yup.string()
      .required(messages.stp4.firstName)
      .test('step four - letters only', messages.util.lettersOnly, function(
        name
      ) {
        return !regexs.hasNonLetters.test(name);
      })
      .min(2, messages.stp4.firstName)
      .max(50, messages.stp4.firstName),
    stp4_maidenName: Yup.string()
      .test('step four - letters only', messages.util.lettersOnly, function(
        name
      ) {
        return !regexs.hasNonLetters.test(name);
      })
      .min(2, messages.stp4.maidenName)
      .max(50, messages.stp4.maidenName),
    stp4_lastName: Yup.string()
      .required(messages.stp4.lastName)
      .test('step four - letters only', messages.util.lettersOnly, function(
        name
      ) {
        return regexs.lettersSpacesHyphen.test(name);
      })
      .min(2, messages.stp4.lastName)
      .max(50, messages.stp4.lastName),
    stp4_emailAddress: Yup.string()
      .required(messages.stp4.emailAddress)
      .email(messages.stp4.emailAddressValid),
    stp4_telephone: Yup.string()
      .required(messages.stp4.contactNo)
      .test(
        'step four - contact no valid',
        messages.stp4.contactNoValid,
        function(contactNo) {
          return regexs.contactNoValid.test(contactNo);
        }
      ),

    stp4_dob: Yup.string()
      .required(messages.stp4.dob)
      .test('step four - missing dob', messages.stp4.dob, function(val) {
        return moment(val, 'DD/MM/YYYY', true).isValid();
      })
      .test(
        'step four - must be older than 18',
        messages.stp4.dobValid,
        function(val) {
          let dob = moment(val, 'DD/MM/YYYY');
          let eighteenYrs = moment().subtract(18, 'years');
          return dob.isBefore(eighteenYrs, 'day');
        }
      ),
    stp4_gender: Yup.string().required(messages.stp4.gender),

    stp4_nationalInsurance: Yup.string()
      .test('step four - valid NI', messages.stp4.nationalInsurance, function(
        niNum
      ) {
        return niNum ? regexs.nationalInsuranceValid.test(niNum) : true;
      })
  });

  Step5Schema = Yup.object().shape({
    stp5_consentPermission: Yup.bool().oneOf(
      [true],
      'You must agree to this to continue.'
    ),
    stp5_consentPrivacy: Yup.bool().oneOf(
      [true],
      'You must agree to this to continue.'
    ),
    stp5_consentIdentity: Yup.bool().oneOf(
      [true],
      'You must agree to this to continue.'
    )
  });

  Step6Schema = Yup.object().shape({
    stp6_infoSheetRead: Yup.bool().oneOf([true], '')
  });

  Step7Schema = Yup.object().shape({
    stp7_dbaAgreed: Yup.bool().oneOf([true], ''),
    stp7_dbaAgreedSignature: Yup.string()
      .required('You must sign the form to continue')
      .trim('Signature cannot include leading and trailing spaces')
      .strict(true)
      .test('signature - letters only', messages.util.lettersAndSpacesOnly, function(
        name
      ) {
        return regexs.lettersAndSpaces.test(name);
      })
      .min(1, 'You must enter at least one character to sign')
      .max(50, 'Your signature should not be more than 50 characters')
  });

  DocumentUploadSchema = Yup.object().shape({
    stpDocUpload_type: Yup.string().required(messages.docUpload.type),
    stpDocUpload_file: Yup.string().required(messages.docUpload.file)
  });

  PayslipSchema = Yup.object().shape({
    aq_jobTitle: Yup.string()
      .required('Please provide your job title'),
    aq_nationalInsurance: Yup.string()
      .required(messages.payslip.aq_nationalInsurance)
      .test('aq - valid NI', messages.payslip.aq_nationalInsurance, function(
        niNum
      ) {
        return regexs.nationalInsuranceValid.test(niNum);
      }),
    aq_dateStarted: Yup.string()
      .required(messages.payslip.startDate)
      .test('step two - missing start date', messages.payslip.startDate, function(
        val
      ) {
        return moment(val, 'DD/MM/YYYY', true).isValid();
      })
      .test(
        'step two - start date cannot be in the future',
        messages.payslip.startDateFuture,
        function(val) {
          let endDate = moment(val, 'DD/MM/YYYY');
          let today = moment();
          return endDate.isBefore(today, 'day');
        }
      ),
    aq_dateEnded: Yup.string()
      .test('payslip - missing end date', messages.payslip.endDate, function(
        val
      ) {
        if (!val || val.length === 0) return true;
        return moment(val, 'DD/MM/YYYY', true).isValid();
      })
      .test(
        'payslip - end date cannot be in the future',
        messages.payslip.endDateFuture,
        function(val) {
          let endDate = moment(val, 'DD/MM/YYYY');
          let today = moment();
          if (!val || val.length === 0) return true;
          return endDate.isBefore(today, 'day');
        }
      )
      .test(
        'payslip - end date cannot be before start date',
        messages.payslip.endBeforeStart,
        function(val) {
          if (!val || val.length === 0) return true;
          let startDate = moment(
            this.resolve(Yup.ref('aq_dateStarted')),
            'DD/MM/YYYY'
          );
          let endDate = moment(val, 'DD/MM/YYYY');
          return endDate.isAfter(startDate, 'day');
        }
      ),
    aq_jobChangedLastSixYears: Yup.string()
      .required(messages.payslip.aq_jobChangedLastSixYears),
    aq_filePayslip: Yup.string().required(messages.docUpload.file)
  });

  QuestionnaireSchema = Yup.object().shape({
    aq_jobTitle: Yup.string()
      .required('Please provide your job title'),
    aq_nationalInsurance: Yup.string()
      .required(messages.questionnaire.aq_nationalInsurance)
      .test('aq - valid NI', messages.questionnaire.aq_nationalInsurance, function(
        niNum
      ) {
        return regexs.nationalInsuranceValid.test(niNum);
      }),
    aq_dateStarted: Yup.string()
      .required(messages.questionnaire.startDate)
      .test('step two - missing start date', messages.questionnaire.startDate, function(
        val
      ) {
        return moment(val, 'DD/MM/YYYY', true).isValid();
      })
      .test(
        'step two - start date cannot be in the future',
        messages.questionnaire.startDateFuture,
        function(val) {
          let endDate = moment(val, 'DD/MM/YYYY');
          let today = moment();
          return endDate.isBefore(today, 'day');
        }
      ),
    aq_dateEnded: Yup.string()
      .test('questionnaire - missing end date', messages.questionnaire.endDate, function(
        val
      ) {
        if (!val || val.length === 0) return true;
        return moment(val, 'DD/MM/YYYY', true).isValid();
      })
      .test(
        'questionnaire - end date cannot be in the future',
        messages.questionnaire.endDateFuture,
        function(val) {
          let endDate = moment(val, 'DD/MM/YYYY');
          let today = moment();
          if (!val || val.length === 0) return true;
          return endDate.isBefore(today, 'day');
        }
      )
      .test(
        'questionnaire - end date cannot be before start date',
        messages.questionnaire.endBeforeStart,
        function(val) {
          if (!val || val.length === 0) return true;
          let startDate = moment(
            this.resolve(Yup.ref('aq_dateStarted')),
            'DD/MM/YYYY'
          );
          let endDate = moment(val, 'DD/MM/YYYY');
          return endDate.isAfter(startDate, 'day');
        }
      ),
    aq_jobChangedLastSixYears: Yup.string()
      .required(messages.questionnaire.aq_jobChangedLastSixYears)
  });

  EmailFormSchema = Yup.object().shape({
    email_input: Yup.string()
      .required(messages.email_form.emailAddress)
      .email(messages.email_form.emailAddressValid)
  });

  schemaArray = [
    this.Step1Schema,
    this.Step2Schema,
    this.Step3Schema,
    this.Step4Schema,
    this.Step5Schema,
    this.Step6Schema,
    this.Step7Schema
  ];

  handleSubmit = (values: any, formikbag: any) => {
    // do stuff
    setTimeout(() => {
      formikbag.setSubmitting(false);
    }, 1000);
  };

  formStep = (props: any) => {
    const { step } = this.state;
    switch (step) {
      case 0:
        window.location.replace(process.env.REACT_APP_ERROR_URL || '');
        break;
      case 1:
        return (
          <WorkFormA
            {...props}
            nextStep={this.nextStep}
            gaEvent={this.gaEvent}
          />
        );
      case 2:
        return (
          <WorkFormB
            {...props}
            nextStep={this.nextStep}
            gaEvent={this.gaEvent}
          />
        );
      case 3:
        return (
          <AddressForm
            {...props}
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            gaEvent={this.gaEvent}
          />
        );
      case 4:
        return (
          <PersonalDetailsForm
            {...props}
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            gaEvent={this.gaEvent}
          />
        );
      case 5:
        return (
          <ConsentForm
            {...props}
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            gaEvent={this.gaEvent}
          />
        );
      case 6:
        return (
          <InformationSheetForm
            {...props}
            nextStep={this.nextStep}
            gaEvent={this.gaEvent}
          />
        );
      case 7:
        return (
          <DBAFormTwo
            {...props}
            nextStep={this.nextStep}
            gaEvent={this.gaEvent}
          />
        );
      case 8:
        return (
          <OnfidoInitialCheck
            {...props}
            leadId={this.state.leadId}
            manualStep={this.manualStep}
            gaEvent={this.gaEvent}
          />
        );
      case 9:
        return (
          <OnfidoDocumentUpload
            {...props}
            leadId={this.state.leadId}
            manualStep={this.manualStep}
            gaEvent={this.gaEvent}
          />
        );
      case 'ADDITIONAL_QUESTIONS_SELECTOR':
        return (
          <AQSelector
            {...props}
            leadId={this.state.leadId}
            manualStep={this.manualStep}
            gaEvent={this.gaEvent}
          />
        );
      case 'PAYSLIP':
        return (
          <AQPayslip
            {...props}
            leadId={this.state.leadId}
            manualStep={this.manualStep}
            gaEvent={this.gaEvent}
          />
        );
      case 'QUESTIONNAIRE':
        return (
          <AQQuestionnaire
            {...props}
            leadId={this.state.leadId}
            manualStep={this.manualStep}
            gaEvent={this.gaEvent}
          />
        );
      case 'PREVIOUS_JOBS':
        return (
          <AQPreviousJobs
            {...props}
            leadId={this.state.leadId}
            manualStep={this.manualStep}
            backStep={this.state.backStep}
            gaEvent={this.gaEvent}
          />
        );
      case 'EMAIL_FORM':
        return (
          <EmailForm
            {...props}
            manualStep={this.manualStep}
            routeLead={this.routeRevisitingLead}
          />
        );
      case 'FINALLY':
        //TODO: Will remove / fix this later
        setTimeout(() => {
          window.location.replace(process.env.REACT_APP_CONFIRMATION_URL || '');
        }, 3000);
        break;
    }
  };

  onKeyDown = (keyEvent: any) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault();
    }
  }

  render() {
    return (
      <React.Fragment>
        <PJModal
          size={this.state.modalSize}
          open={this.state.modalOpen}
          content={this.state.modalContent}
        />
        <Grid
          centered={true}
          textAlign="center"
          verticalAlign="top"
        >
          <Grid.Column style={{ margin: '0 15px' }}>

            {/* <Header
            as="h2"
            color="teal"
            textAlign="center"
            style={{ marginTop: '12px' }}
          >
            Pay Justice React Form
          </Header> */}


            {/* {this.state.percent ? <Header
            as="h3"
            color="red"
            textAlign="center"
            style={{ marginTop: '12px' }}
          >
            {motivationMsg[this.state.motivation]}
          </Header> : null
          } */}

            <Formik
              onSubmit={this.handleSubmit}
              enableReinitialize={true}
              initialValues={{ ...this.state.formData }}
              validationSchema={this.getValidationSchema()}
              render={props => (
                <div style={{ border: '3px solid #8298af', borderRadius: '10px', padding: '10px', marginBottom: '10px' }}>
                  <Form className="ui large form" onKeyDown={this.onKeyDown}>
                    <Segment stacked>{this.formStep(props)}</Segment>
                    {/* <DisplayFormikState {...props} /> */}
                    <span className="payjustice-formstep" style={{ display: 'none' }} data-payjustice-formstep={this.state.step}>{this.state.step}</span>
                  </Form>
                </div>
              )}
            />

            {this.state.percent &&
              this.state.step !== 'EMAIL_FORM' &&
              this.state.step !== 6 &&
              this.state.step !== 7 &&
              this.state.step !== 8 &&
              this.state.step !== 9 ?
              <div>
                <Progress percent={this.state.percent} indicating />
              </div> : null
            }

          </Grid.Column>
        </Grid>
      </React.Fragment>
    );
  }
}

export default App;
